module.exports = __webpack_public_path__ + "img/send-bill-and-receipt-2-en.78119ba.png";